import { useEffect, useState } from "react";
import { MapPin, Navigation } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import api from "../../lib/api";

export const LocationSection = () => {
  const { t } = useLanguage();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  const address = settings ? `${settings.address}, ${settings.postal_code} ${settings.city}` : "Vlampijpstraat 75g, 3534 AR Utrecht";
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

  return (
    <section data-testid="location-section" className="py-20 sm:py-28 px-4 sm:px-6 bg-[#080808]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
        <div>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-white mb-6 tracking-tight">{t("location.title")}</h2>
          <p className="flex items-start gap-3 text-white/80 mb-6">
            <MapPin className="text-gold shrink-0 mt-1" size={20} />
            <span>{address}<br />Nederland</span>
          </p>
          <a
            href={directionsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="location-directions-link"
            className="inline-flex items-center gap-2 bg-gold text-white px-6 py-3 hover:bg-gold-hover transition-colors"
          >
            <Navigation size={16} /> {t("location.directions")}
          </a>
        </div>
        <div className="aspect-[4/3] rounded-xl overflow-hidden border border-white/10">
          <iframe
            data-testid="location-map-iframe"
            title="EliteTheBarber locatie"
            src={settings?.google_maps_embed_url || "https://www.google.com/maps?q=Vlampijpstraat+75g,+3534+AR+Utrecht&output=embed"}
            width="100%"
            height="100%"
            style={{ border: 0, filter: "grayscale(0.3) invert(0.92) contrast(0.9)" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};
